import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { teamsList, getTeamGroups } from '../../services/teams';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import ClubProfile from './profile';
import AgeSlider from '../../components/AgeSlider';
import { PracticeCalendar } from '../../components/PracticeCalendar';

const ClubHomepage = () => {
  const animatedComponents = makeAnimated();

  const { t } = useTranslation();

  const [filters, setFilters] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const { teams } = await teamsList();
      const { groups } = await getTeamGroups();
      const groupedTeams = groups.map(({ id, name, position}) => ({
        id,
        name,
        teams: teams.filter(t => t.team_group_id === id),
        position
      }));
      groupedTeams.push({
        name: '',
        teams: teams.filter(t => !t.team_group_id),
      });
      groupedTeams.sort((a, b) => Number(a.position) - Number(b.position));
      setGroups(groupedTeams);
    };

    fetchData();
  }, []);

  const selectOptions = groups.map(({ name, teams }) => ({
    label: (
      <div
        onClick={() =>
          setSelectedOptions(value => [
            ...value,
            ...teams.flatMap(t => (value.some(v => v.value === t.id) ? [] : [{ value: t.id, label: t.name }])),
          ])
        }
      >
        {name}
      </div>
    ),
    options: teams.map(t => ({ value: t.id, label: t.name })),
  }));

  useEffect(() => {
    setFilters(prev => ({ ...prev, team_ids: selectedOptions.map(o => o.value) }));
  }, [selectedOptions]);

  return (
    <div className="club-home">
      <ClubProfile groups={groups} setGroups={setGroups}/>

      <div className="club-home-filters">
        <div className="club-home-filters-teams">
          <Select
            closeMenuOnSelect={false}
            components={animatedComponents}
            isMulti
            options={selectOptions}
            styles={customStyles}
            placeholder={t('club.placeholder')}
            onChange={options => setSelectedOptions(options)}
            value={selectedOptions}
          />
        </div>
        <div className="club-home-filters-ages">
          <AgeSlider
            minimum_age={filters.from_age}
            maximum_age={filters.to_age}
            onChange={({ minimum_age, maximum_age }) => setFilters({ ...filters, from_age: minimum_age, to_age: maximum_age })}
          />
        </div>
      </div>
      <PracticeCalendar filters={filters}/>
    </div>
  );
};

export default memo(ClubHomepage);

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#F7F7F7',
    border: 'none',
    boxShadow: 'none',
  }),
  multiValue: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: 'none',
    };
  },
};
